---
- name: United States
  alpha2: US
  alpha3: USA
  emoji: 🇺🇸
  telcodes: ["+1"]

- name: India
  alpha2: IN
  alpha3: IND
  emoji: 🇮🇳
  telcodes: ["+91"]

- name: Afghanistan
  alpha2: AF
  alpha3: AFG
  emoji: 🇦🇫
  telcodes: ["+93"]

- name: Albania
  alpha2: AL
  alpha3: ALB
  emoji: 🇦🇱
  telcodes: ["+355"]

- name: Algeria
  alpha2: DZ
  alpha3: DZA
  emoji: 🇩🇿
  telcodes: ["+213"]

- name: American Samoa
  alpha2: AS
  alpha3: ASM
  emoji: 🇦🇸
  telcodes: ["+1 684"]

- name: Andorra
  alpha2: AD
  alpha3: AND
  emoji: 🇦🇩
  telcodes: ["+376"]

- name: Angola
  alpha2: AO
  alpha3: AGO
  emoji: 🇦🇴
  telcodes: ["+244"]

- name: Antigua And Barbuda
  alpha2: AG
  alpha3: ATG
  emoji: 🇦🇬
  telcodes: ["+1 268"]

- name: Argentina
  alpha2: AR
  alpha3: ARG
  emoji: 🇦🇷
  telcodes: ["+54"]

- name: Armenia
  alpha2: AM
  alpha3: ARM
  emoji: 🇦🇲
  telcodes: ["+374"]

- name: Aruba
  alpha2: AW
  alpha3: ABW
  emoji: 🇦🇼
  telcodes: ["+297"]

- name: Australia
  alpha2: AU
  alpha3: AUS
  emoji: 🇦🇺
  telcodes: ["+61"]

- name: Austria
  alpha2: AT
  alpha3: AUT
  emoji: 🇦🇹
  telcodes: ["+43"]

- name: Azerbaijan
  alpha2: AZ
  alpha3: AZE
  emoji: 🇦🇿
  telcodes: ["+994"]

- name: Bahamas
  alpha2: BS
  alpha3: BHS
  emoji: 🇧🇸
  telcodes: ["+1 242"]

- name: Bahrain
  alpha2: BH
  alpha3: BHR
  emoji: 🇧🇭
  telcodes: ["+973"]

- name: Bangladesh
  alpha2: BD
  alpha3: BGD
  emoji: 🇧🇩
  telcodes: ["+880"]

- name: Barbados
  alpha2: BB
  alpha3: BRB
  emoji: 🇧🇧
  telcodes: ["+1 246"]

- name: Belarus
  alpha2: BY
  alpha3: BLR
  emoji: 🇧🇾
  telcodes: ["+375"]

- name: Belgium
  alpha2: BE
  alpha3: BEL
  emoji: 🇧🇪
  telcodes: ["+32"]

- name: Belize
  alpha2: BZ
  alpha3: BLZ
  emoji: 🇧🇿
  telcodes: ["+501"]

- name: Benin
  alpha2: BJ
  alpha3: BEN
  emoji: 🇧🇯
  telcodes: ["+229"]

- name: Bermuda
  alpha2: BM
  alpha3: BMU
  emoji: 🇧🇲
  telcodes: ["+1 441"]

- name: Bhutan
  alpha2: BT
  alpha3: BTN
  emoji: 🇧🇹
  telcodes: ["+975"]

- name: Bolivia, Plurinational State Of
  alpha2: BO
  alpha3: BOL
  emoji: 🇧🇴
  telcodes: ["+591"]

- name: Bosnia & Herzegovina
  alpha2: BA
  alpha3: BIH
  emoji: 🇧🇦
  telcodes: ["+387"]

- name: Botswana
  alpha2: BW
  alpha3: BWA
  emoji: 🇧🇼
  telcodes: ["+267"]

- name: Brazil
  alpha2: BR
  alpha3: BRA
  emoji: 🇧🇷
  telcodes: ["+55"]

- name: Brunei Darussalam
  alpha2: BN
  alpha3: BRN
  emoji: 🇧🇳
  telcodes: ["+673"]

- name: Bulgaria
  alpha2: BG
  alpha3: BGR
  emoji: 🇧🇬
  telcodes: ["+359"]

- name: Burkina Faso
  alpha2: BF
  alpha3: BFA
  emoji: 🇧🇫
  telcodes: ["+226"]

- name: Burundi
  alpha2: BI
  alpha3: BDI
  emoji: 🇧🇮
  telcodes: ["+257"]

- name: Cabo Verde
  alpha2: CV
  alpha3: CPV
  emoji: 🇨🇻
  telcodes: ["+238"]

- name: Cambodia
  alpha2: KH
  alpha3: KHM
  emoji: 🇰🇭
  telcodes: ["+855"]

- name: Cameroon
  alpha2: CM
  alpha3: CMR
  emoji: 🇨🇲
  telcodes: ["+237"]

- name: Canada
  alpha2: CA
  alpha3: CAN
  emoji: 🇨🇦
  telcodes: ["+1"]

- name: Cayman Islands
  alpha2: KY
  alpha3: CYM
  emoji: 🇰🇾
  telcodes: ["+1 345"]

- name: Central African Republic
  alpha2: CF
  alpha3: CAF
  emoji: 🇨🇫
  telcodes: ["+236"]

- name: Chad
  alpha2: TD
  alpha3: TCD
  emoji: 🇹🇩
  telcodes: ["+235"]

- name: Chile
  alpha2: CL
  alpha3: CHL
  emoji: 🇨🇱
  telcodes: ["+56"]

- name: China
  alpha2: CN
  alpha3: CHN
  emoji: 🇨🇳
  telcodes: ["+86"]

- name: Colombia
  alpha2: CO
  alpha3: COL
  emoji: 🇨🇴
  telcodes: ["+57"]

- name: Comoros
  alpha2: KM
  alpha3: COM
  emoji: 🇰🇲
  telcodes: ["+269"]

- name: Cook Islands
  alpha2: CK
  alpha3: COK
  emoji: 🇨🇰
  telcodes: ["+682"]

- name: Costa Rica
  alpha2: CR
  alpha3: CRI
  emoji: 🇨🇷
  telcodes: ["+506"]

- name: Croatia
  alpha2: HR
  alpha3: HRV
  emoji: 🇭🇷
  telcodes: ["+385"]

- name: Cuba
  alpha2: CU
  alpha3: CUB
  emoji: 🇨🇺
  telcodes: ["+53"]

- name: Cyprus
  alpha2: CY
  alpha3: CYP
  emoji: 🇨🇾
  telcodes: ["+357"]

- name: Czech Republic
  alpha2: CZ
  alpha3: CZE
  emoji: 🇨🇿
  telcodes: ["+420"]

- name: Côte d'Ivoire
  alpha2: CI
  alpha3: CIV
  emoji: 🇨🇮
  telcodes: ["+225"]

- name: Democratic Republic Of Congo
  alpha2: CD
  alpha3: COD
  emoji: 🇨🇩
  telcodes: ["+243"]

- name: Denmark
  alpha2: DK
  alpha3: DNK
  emoji: 🇩🇰
  telcodes: ["+45"]

- name: Djibouti
  alpha2: DJ
  alpha3: DJI
  emoji: 🇩🇯
  telcodes: ["+253"]

- name: Dominica
  alpha2: DM
  alpha3: DMA
  emoji: 🇩🇲
  telcodes: ["+1 767"]

- name: Dominican Republic
  alpha2: DO
  alpha3: DOM
  emoji: 🇩🇴
  telcodes: ["+1 809", "+1 829", "+1 849"]

- name: Ecuador
  alpha2: EC
  alpha3: ECU
  emoji: 🇪🇨
  telcodes: ["+593"]

- name: Egypt
  alpha2: EG
  alpha3: EGY
  emoji: 🇪🇬
  telcodes: ["+20"]

- name: El Salvador
  alpha2: SV
  alpha3: SLV
  emoji: 🇸🇻
  telcodes: ["+503"]

- name: Equatorial Guinea
  alpha2: GQ
  alpha3: GNQ
  emoji: 🇬🇶
  telcodes: ["+240"]

- name: Eritrea
  alpha2: ER
  alpha3: ERI
  emoji: 🇪🇷
  telcodes: ["+291"]

- name: Estonia
  alpha2: EE
  alpha3: EST
  emoji: 🇪🇪
  telcodes: ["+372"]

- name: Ethiopia
  alpha2: ET
  alpha3: ETH
  emoji: 🇪🇹
  telcodes: ["+251"]

- name: Faroe Islands
  alpha2: FO
  alpha3: FRO
  emoji: 🇫🇴
  telcodes: ["+298"]

- name: Fiji
  alpha2: FJ
  alpha3: FJI
  emoji: 🇫🇯
  telcodes: ["+679"]

- name: Finland
  alpha2: FI
  alpha3: FIN
  emoji: 🇫🇮
  telcodes: ["+358"]

- name: France
  alpha2: FR
  alpha3: FRA
  emoji: 🇫🇷
  telcodes: ["+33"]

- name: Gabon
  alpha2: GA
  alpha3: GAB
  emoji: 🇬🇦
  telcodes: ["+241"]

- name: Gambia
  alpha2: GM
  alpha3: GMB
  emoji: 🇬🇲
  telcodes: ["+220"]

- name: Georgia
  alpha2: GE
  alpha3: GEO
  emoji: 🇬🇪
  telcodes: ["+995"]

- name: Germany
  alpha2: DE
  alpha3: DEU
  emoji: 🇩🇪
  telcodes: ["+49"]

- name: Ghana
  alpha2: GH
  alpha3: GHA
  emoji: 🇬🇭
  telcodes: ["+233"]

- name: Greece
  alpha2: GR
  alpha3: GRC
  emoji: 🇬🇷
  telcodes: ["+30"]

- name: Grenada
  alpha2: GD
  alpha3: GRD
  emoji: 🇬🇩
  telcodes: ["+473"]

- name: Guam
  alpha2: GU
  alpha3: GUM
  emoji: 🇬🇺
  telcodes: ["+1 671"]

- name: Guatemala
  alpha2: GT
  alpha3: GTM
  emoji: 🇬🇹
  telcodes: ["+502"]

- name: Guernsey
  alpha2: GG
  alpha3: GGY
  emoji: 🇬🇬
  telcodes: ["+44"]

- name: Guinea
  alpha2: GN
  alpha3: GIN
  emoji: 🇬🇳
  telcodes: ["+224"]

- name: Guinea-bissau
  alpha2: GW
  alpha3: GNB
  emoji: 🇬🇼
  telcodes: ["+245"]

- name: Guyana
  alpha2: GY
  alpha3: GUY
  emoji: 🇬🇾
  telcodes: ["+592"]

- name: Haiti
  alpha2: HT
  alpha3: HTI
  emoji: 🇭🇹
  telcodes: ["+509"]

- name: Honduras
  alpha2: HN
  alpha3: HND
  emoji: 🇭🇳
  telcodes: ["+504"]

- name: Hong Kong
  alpha2: HK
  alpha3: HKG
  emoji: 🇭🇰
  telcodes: ["+852"]

- name: Hungary
  alpha2: HU
  alpha3: HUN
  emoji: 🇭🇺
  telcodes: ["+36"]

- name: Iceland
  alpha2: IS
  alpha3: ISL
  emoji: 🇮🇸
  telcodes: ["+354"]

- name: Indonesia
  alpha2: ID
  alpha3: IDN
  emoji: 🇮🇩
  telcodes: ["+62"]

- name: Iran, Islamic Republic Of
  alpha2: IR
  alpha3: IRN
  emoji: 🇮🇷
  telcodes: ["+98"]

- name: Iraq
  alpha2: IQ
  alpha3: IRQ
  emoji: 🇮🇶
  telcodes: ["+964"]

- name: Ireland
  alpha2: IE
  alpha3: IRL
  emoji: 🇮🇪
  telcodes: ["+353"]

- name: Israel
  alpha2: IL
  alpha3: ISR
  emoji: 🇮🇱
  telcodes: ["+972"]

- name: Italy
  alpha2: IT
  alpha3: ITA
  emoji: 🇮🇹
  telcodes: ["+39"]

- name: Jamaica
  alpha2: JM
  alpha3: JAM
  emoji: 🇯🇲
  telcodes: ["+1 876"]

- name: Japan
  alpha2: JP
  alpha3: JPN
  emoji: 🇯🇵
  telcodes: ["+81"]

- name: Jersey
  alpha2: JE
  alpha3: JEY
  emoji: 🇯🇪
  telcodes: ["+44"]

- name: Jordan
  alpha2: JO
  alpha3: JOR
  emoji: 🇯🇴
  telcodes: ["+962"]

- name: Kazakhstan
  alpha2: KZ
  alpha3: KAZ
  emoji: 🇰🇿
  telcodes: ["+7", "+7 6", "+7 7"]

- name: Kenya
  alpha2: KE
  alpha3: KEN
  emoji: 🇰🇪
  telcodes: ["+254"]

- name: Kiribati
  alpha2: KI
  alpha3: KIR
  emoji: 🇰🇮
  telcodes: ["+686"]

- name: Korea, Democratic People's Republic Of
  alpha2: KP
  alpha3: PRK
  emoji: 🇰🇵
  telcodes: ["+850"]

- name: Korea, Republic Of
  alpha2: KR
  alpha3: KOR
  emoji: 🇰🇷
  telcodes: ["+82"]

- name: Kuwait
  alpha2: KW
  alpha3: KWT
  emoji: 🇰🇼
  telcodes: ["+965"]

- name: Kyrgyzstan
  alpha2: KG
  alpha3: KGZ
  emoji: 🇰🇬
  telcodes: ["+996"]

- name: Lao People's Democratic Republic
  alpha2: LA
  alpha3: LAO
  emoji: 🇱🇦
  telcodes: ["+856"]

- name: Latvia
  alpha2: LV
  alpha3: LVA
  emoji: 🇱🇻
  telcodes: ["+371"]

- name: Lebanon
  alpha2: LB
  alpha3: LBN
  emoji: 🇱🇧
  telcodes: ["+961"]

- name: Lesotho
  alpha2: LS
  alpha3: LSO
  emoji: 🇱🇸
  telcodes: ["+266"]

- name: Liberia
  alpha2: LR
  alpha3: LBR
  emoji: 🇱🇷
  telcodes: ["+231"]

- name: Libya
  alpha2: LY
  alpha3: LBY
  emoji: 🇱🇾
  telcodes: ["+218"]

- name: Liechtenstein
  alpha2: LI
  alpha3: LIE
  emoji: 🇱🇮
  telcodes: ["+423"]

- name: Lithuania
  alpha2: LT
  alpha3: LTU
  emoji: 🇱🇹
  telcodes: ["+370"]

- name: Luxembourg
  alpha2: LU
  alpha3: LUX
  emoji: 🇱🇺
  telcodes: ["+352"]

- name: Macao
  alpha2: MO
  alpha3: MAC
  emoji: 🇲🇴
  telcodes: ["+853"]

- name: Macedonia, The Former Yugoslav Republic Of
  alpha2: MK
  alpha3: MKD
  emoji: 🇲🇰
  telcodes: ["+389"]

- name: Madagascar
  alpha2: MG
  alpha3: MDG
  emoji: 🇲🇬
  telcodes: ["+261"]

- name: Malawi
  alpha2: MW
  alpha3: MWI
  emoji: 🇲🇼
  telcodes: ["+265"]

- name: Malaysia
  alpha2: MY
  alpha3: MYS
  emoji: 🇲🇾
  telcodes: ["+60"]

- name: Maldives
  alpha2: MV
  alpha3: MDV
  emoji: 🇲🇻
  telcodes: ["+960"]

- name: Mali
  alpha2: ML
  alpha3: MLI
  emoji: 🇲🇱
  telcodes: ["+223"]

- name: Malta
  alpha2: MT
  alpha3: MLT
  emoji: 🇲🇹
  telcodes: ["+356"]

- name: Marshall Islands
  alpha2: MH
  alpha3: MHL
  emoji: 🇲🇭
  telcodes: ["+692"]

- name: Mauritania
  alpha2: MR
  alpha3: MRT
  emoji: 🇲🇷
  telcodes: ["+222"]

- name: Mauritius
  alpha2: MU
  alpha3: MUS
  emoji: 🇲🇺
  telcodes: ["+230"]

- name: Mexico
  alpha2: MX
  alpha3: MEX
  emoji: 🇲🇽
  telcodes: ["+52"]

- name: Micronesia, Federated States Of
  alpha2: FM
  alpha3: FSM
  emoji: 🇫🇲
  telcodes: ["+691"]

- name: Moldova
  alpha2: MD
  alpha3: MDA
  emoji: 🇲🇩
  telcodes: ["+373"]

- name: Monaco
  alpha2: MC
  alpha3: MCO
  emoji: 🇲🇨
  telcodes: ["+377"]

- name: Mongolia
  alpha2: MN
  alpha3: MNG
  emoji: 🇲🇳
  telcodes: ["+976"]

- name: Montenegro
  alpha2: ME
  alpha3: MNE
  emoji: 🇲🇪
  telcodes: ["+382"]

- name: Morocco
  alpha2: MA
  alpha3: MAR
  emoji: 🇲🇦
  telcodes: ["+212"]

- name: Mozambique
  alpha2: MZ
  alpha3: MOZ
  emoji: 🇲🇿
  telcodes: ["+258"]

- name: Myanmar
  alpha2: MM
  alpha3: MMR
  emoji: 🇲🇲
  telcodes: ["+95"]

- name: Namibia
  alpha2: NA
  alpha3: NAM
  emoji: 🇳🇦
  telcodes: ["+264"]

- name: Nauru
  alpha2: NR
  alpha3: NRU
  emoji: 🇳🇷
  telcodes: ["+674"]

- name: Nepal
  alpha2: NP
  alpha3: NPL
  emoji: 🇳🇵
  telcodes: ["+977"]

- name: Netherlands
  alpha2: NL
  alpha3: NLD
  emoji: 🇳🇱
  telcodes: ["+31"]

- name: New Zealand
  alpha2: NZ
  alpha3: NZL
  emoji: 🇳🇿
  telcodes: ["+64"]

- name: Nicaragua
  alpha2: NI
  alpha3: NIC
  emoji: 🇳🇮
  telcodes: ["+505"]

- name: Niger
  alpha2: NE
  alpha3: NER
  emoji: 🇳🇪
  telcodes: ["+227"]

- name: Nigeria
  alpha2: NG
  alpha3: NGA
  emoji: 🇳🇬
  telcodes: ["+234"]

- name: Norway
  alpha2: NO
  alpha3: NOR
  emoji: 🇳🇴
  telcodes: ["+47"]

- name: Oman
  alpha2: OM
  alpha3: OMN
  emoji: 🇴🇲
  telcodes: ["+968"]

- name: Pakistan
  alpha2: PK
  alpha3: PAK
  emoji: 🇵🇰
  telcodes: ["+92"]

- name: Palau
  alpha2: PW
  alpha3: PLW
  emoji: 🇵🇼
  telcodes: ["+680"]

- name: Palestinian Territory, Occupied
  alpha2: PS
  alpha3: PSE
  emoji: 🇵🇸
  telcodes: ["+970"]

- name: Panama
  alpha2: PA
  alpha3: PAN
  emoji: 🇵🇦
  telcodes: ["+507"]

- name: Papua New Guinea
  alpha2: PG
  alpha3: PNG
  emoji: 🇵🇬
  telcodes: ["+675"]

- name: Paraguay
  alpha2: PY
  alpha3: PRY
  emoji: 🇵🇾
  telcodes: ["+595"]

- name: Peru
  alpha2: PE
  alpha3: PER
  emoji: 🇵🇪
  telcodes: ["+51"]

- name: Philippines
  alpha2: PH
  alpha3: PHL
  emoji: 🇵🇭
  telcodes: ["+63"]

- name: Poland
  alpha2: PL
  alpha3: POL
  emoji: 🇵🇱
  telcodes: ["+48"]

- name: Portugal
  alpha2: PT
  alpha3: PRT
  emoji: 🇵🇹
  telcodes: ["+351"]

- name: Puerto Rico
  alpha2: PR
  alpha3: PRI
  emoji: 🇵🇷
  telcodes: ["+1 787", "+1 939"]

- name: Qatar
  alpha2: QA
  alpha3: QAT
  emoji: 🇶🇦
  telcodes: ["+974"]

- name: Republic Of Congo
  alpha2: CG
  alpha3: COG
  emoji: 🇨🇬
  telcodes: ["+242"]

- name: Romania
  alpha2: RO
  alpha3: ROU
  emoji: 🇷🇴
  telcodes: ["+40"]

- name: Russian Federation
  alpha2: RU
  alpha3: RUS
  emoji: 🇷🇺
  telcodes: ["+7", "+7 3", "+7 4", "+7 8"]

- name: Rwanda
  alpha2: RW
  alpha3: RWA
  emoji: 🇷🇼
  telcodes: ["+250"]

- name: Saint Kitts And Nevis
  alpha2: KN
  alpha3: KNA
  emoji: 🇰🇳
  telcodes: ["+1 869"]

- name: Saint Lucia
  alpha2: LC
  alpha3: LCA
  emoji: 🇱🇨
  telcodes: ["+1 758"]

- name: Saint Vincent And The Grenadines
  alpha2: VC
  alpha3: VCT
  emoji: 🇻🇨
  telcodes: ["+1 784"]

- name: Samoa
  alpha2: WS
  alpha3: WSM
  emoji: 🇼🇸
  telcodes: ["+685"]

- name: San Marino
  alpha2: SM
  alpha3: SMR
  emoji: 🇸🇲
  telcodes: ["+378"]

- name: Sao Tome and Principe
  alpha2: ST
  alpha3: STP
  emoji: 🇸🇹
  telcodes: ["+239"]

- name: Saudi Arabia
  alpha2: SA
  alpha3: SAU
  emoji: 🇸🇦
  telcodes: ["+966"]

- name: Senegal
  alpha2: SN
  alpha3: SEN
  emoji: 🇸🇳
  telcodes: ["+221"]

- name: Serbia
  alpha2: RS
  alpha3: SRB
  emoji: 🇷🇸
  telcodes: ["+381"]

- name: Seychelles
  alpha2: SC
  alpha3: SYC
  emoji: 🇸🇨
  telcodes: ["+248"]

- name: Sierra Leone
  alpha2: SL
  alpha3: SLE
  emoji: 🇸🇱
  telcodes: ["+232"]

- name: Singapore
  alpha2: SG
  alpha3: SGP
  emoji: 🇸🇬
  telcodes: ["+65"]

- name: Slovakia
  alpha2: SK
  alpha3: SVK
  emoji: 🇸🇰
  telcodes: ["+421"]

- name: Slovenia
  alpha2: SI
  alpha3: SVN
  emoji: 🇸🇮
  telcodes: ["+386"]

- name: Solomon Islands
  alpha2: SB
  alpha3: SLB
  emoji: 🇸🇧
  telcodes: ["+677"]

- name: Somalia
  alpha2: SO
  alpha3: SOM
  emoji: 🇸🇴
  telcodes: ["+252"]

- name: South Africa
  alpha2: ZA
  alpha3: ZAF
  emoji: 🇿🇦
  telcodes: ["+27"]

- name: South Sudan
  alpha2: SS
  alpha3: SSD
  emoji: 🇸🇸
  telcodes: ["+211"]

- name: Spain
  alpha2: ES
  alpha3: ESP
  emoji: 🇪🇸
  telcodes: ["+34"]

- name: Sri Lanka
  alpha2: LK
  alpha3: LKA
  emoji: 🇱🇰
  telcodes: ["+94"]

- name: Sudan
  alpha2: SD
  alpha3: SDN
  emoji: 🇸🇩
  telcodes: ["+249"]

- name: Suriname
  alpha2: SR
  alpha3: SUR
  emoji: 🇸🇷
  telcodes: ["+597"]

- name: Swaziland
  alpha2: SZ
  alpha3: SWZ
  emoji: 🇸🇿
  telcodes: ["+268"]

- name: Sweden
  alpha2: SE
  alpha3: SWE
  emoji: 🇸🇪
  telcodes: ["+46"]

- name: Switzerland
  alpha2: CH
  alpha3: CHE
  emoji: 🇨🇭
  telcodes: ["+41"]

- name: Syrian Arab Republic
  alpha2: SY
  alpha3: SYR
  emoji: 🇸🇾
  telcodes: ["+963"]

- name: Taiwan
  alpha2: TW
  alpha3: TWN
  emoji: 🇹🇼
  telcodes: ["+886"]

- name: Tajikistan
  alpha2: TJ
  alpha3: TJK
  emoji: 🇹🇯
  telcodes: ["+992"]

- name: Tanzania, United Republic Of
  alpha2: TZ
  alpha3: TZA
  emoji: 🇹🇿
  telcodes: ["+255"]

- name: Thailand
  alpha2: TH
  alpha3: THA
  emoji: 🇹🇭
  telcodes: ["+66"]

- name: Timor-Leste, Democratic Republic of
  alpha2: TL
  alpha3: TLS
  emoji: 🇹🇱
  telcodes: ["+670"]

- name: Togo
  alpha2: TG
  alpha3: TGO
  emoji: 🇹🇬
  telcodes: ["+228"]

- name: Tonga
  alpha2: TO
  alpha3: TON
  emoji: 🇹🇴
  telcodes: ["+676"]

- name: Trinidad And Tobago
  alpha2: TT
  alpha3: TTO
  emoji: 🇹🇹
  telcodes: ["+1 868"]

- name: Tunisia
  alpha2: TN
  alpha3: TUN
  emoji: 🇹🇳
  telcodes: ["+216"]

- name: Turkey
  alpha2: TR
  alpha3: TUR
  emoji: 🇹🇷
  telcodes: ["+90"]

- name: Turkmenistan
  alpha2: TM
  alpha3: TKM
  emoji: 🇹🇲
  telcodes: ["+993"]

- name: Tuvalu
  alpha2: TV
  alpha3: TUV
  emoji: 🇹🇻
  telcodes: ["+688"]

- name: Uganda
  alpha2: UG
  alpha3: UGA
  emoji: 🇺🇬
  telcodes: ["+256"]

- name: Ukraine
  alpha2: UA
  alpha3: UKR
  emoji: 🇺🇦
  telcodes: ["+380"]

- name: United Arab Emirates
  alpha2: AE
  alpha3: ARE
  emoji: 🇦🇪
  telcodes: ["+971"]

- name: United Kingdom
  alpha2: GB
  alpha3: GBR
  emoji: 🇬🇧
  telcodes: ["+44"]

- name: Uruguay
  alpha2: UY
  alpha3: URY
  emoji: 🇺🇾
  telcodes: ["+598"]

- name: Uzbekistan
  alpha2: UZ
  alpha3: UZB
  emoji: 🇺🇿
  telcodes: ["+998"]

- name: Vanuatu
  alpha2: VU
  alpha3: VUT
  emoji: 🇻🇺
  telcodes: ["+678"]

- name: Venezuela, Bolivarian Republic Of
  alpha2: VE
  alpha3: VEN
  emoji: 🇻🇪
  telcodes: ["+58"]

- name: Viet Nam
  alpha2: VN
  alpha3: VNM
  emoji: 🇻🇳
  telcodes: ["+84"]

- name: Virgin Islands (British)
  alpha2: VG
  alpha3: VGB
  emoji: 🇻🇬
  telcodes: ["+1 284"]

- name: Virgin Islands (US)
  alpha2: VI
  alpha3: VIR
  emoji: 🇻🇮
  telcodes: ["+1 340"]

- name: Yemen
  alpha2: YE
  alpha3: YEM
  emoji: 🇾🇪
  telcodes: ["+967"]

- name: Zambia
  alpha2: ZM
  alpha3: ZMB
  emoji: 🇿🇲
  telcodes: ["+260"]

- name: Zimbabwe
  alpha2: ZW
  alpha3: ZWE
  emoji: 🇿🇼
  telcodes: ["+263"]
